import React from "react";
import { Helmet } from "react-helmet";

export default function ContactUs() {
  return (
    <div style={{
      maxWidth: "900px",
      margin: "20px auto",
      padding: "20px 15px",
      fontFamily: "Arial, sans-serif",
      lineHeight: "1.8",
      color: "#1a1a1a",
      backgroundColor: "#fdfdfd",
      borderRadius: "8px",
      boxShadow: "0 4px 15px rgba(0,0,0,0.1)"
    }}>
      {/* SEO Meta */}
      <Helmet>
        <title>Contact SamSoftix GameHub | Feedback & Support</title>
        <meta name="description" content="Contact SamSoftix GameHub for feedback, suggestions, or support. Get in touch with developer Qasim Mehmood Cheema and the GameHub team." />
        <meta name="keywords" content="Contact SamSoftix, GameHub support, feedback, developer Qasim Mehmood Cheema, mini-games" />
      </Helmet>

      {/* Hero Section */}
      <header style={{ textAlign: "center", marginBottom: "40px" }}>
        <h1 style={{ fontSize: "2rem", fontWeight: "700", color: "#0d47a1" }}>
          Contact <span style={{ textShadow: "0 0 10px #00e5ff, 0 0 20px #00b8d4" }}>SamSoftix</span>
        </h1>
        <p style={{ fontSize: "1rem", marginTop: "10px", color: "#333" }}>
          We’d love to hear from you! Feedback, suggestions, or support — reach out to us anytime.
        </p>
      </header>

      {/* Contact Form Section */}
      <section>
        <form style={{
          display: "flex",
          flexDirection: "column",
          gap: "15px"
        }}
        onSubmit={(e) => {
          e.preventDefault();
          alert("Thank you! Your message has been submitted."); // placeholder, replace with email integration
        }}>
          <input 
            type="text" 
            placeholder="Your Name" 
            required 
            style={{
              padding: "10px",
              borderRadius: "5px",
              border: "1px solid #ccc",
              fontSize: "1rem"
            }}
          />
          <input 
            type="email" 
            placeholder="Your Email" 
            required 
            style={{
              padding: "10px",
              borderRadius: "5px",
              border: "1px solid #ccc",
              fontSize: "1rem"
            }}
          />
          <textarea 
            placeholder="Your Message" 
            rows="6" 
            required 
            style={{
              padding: "10px",
              borderRadius: "5px",
              border: "1px solid #ccc",
              fontSize: "1rem",
              resize: "vertical"
            }}
          ></textarea>
          <button 
            type="submit"
            style={{
              padding: "12px",
              backgroundColor: "#0d47a1",
              color: "#fff",
              fontWeight: "700",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              transition: "background-color 0.3s"
            }}
            onMouseOver={e => e.target.style.backgroundColor = "#094080"}
            onMouseOut={e => e.target.style.backgroundColor = "#0d47a1"}
          >
            Send Message
          </button>
        </form>
      </section>

      {/* Contact Info Section */}
      <section style={{ marginTop: "30px", fontSize: "1rem", color: "#333" }}>
        <p>Email: <a href="mailto:samsoftix@gmail.com" style={{ color: "#0d47a1" }}>samsoftix@gmail.com</a></p>
        <p>Developer: <strong>Qasim Mehmood Cheema</strong></p>
      </section>

      {/* Footer Note */}
      <p style={{ marginTop: "40px", fontSize: "0.875rem", color: "#555", textAlign: "center" }}>
        © {new Date().getFullYear()} SamSoftix GameHub. All rights reserved.
      </p>
    </div>
  );
}
